import { ArrowLeft, ArrowRight } from 'lucide-react';
import './ServiceDetail.css';
import ScrollToTop from '../../Components/Scrolltop/Scrolltop';

const DataAnalytics = () => {

   <ScrollToTop />
  return (
    <>
      <section className="service-hero">
        <div className="container">
          <a href="/services" className="back-link">
            <ArrowLeft size={24} /> Back to All Services
          </a>
          <h1>Data Analytics, Digital Solutions & Systems Strengthening</h1>
          <p className="lead">
            We apply advanced analytics and digital tools to strengthen institutional systems, improve targeting, forecasting, and performance management, and enable data-driven transformation.
          </p>
        </div>
      </section>

      <section className="section service-detail">
        <div className="container">
          <h2>Our Key Services</h2>
          <ul className="service-list">
            <li>
              <strong>Advanced statistical modelling and predictive analytics</strong>
              <p>Forecasting trends, identifying key drivers, and modelling scenarios to support strategic decisions.</p>
            </li>
            <li>
              <strong>Dashboards, data visualisation, and performance tracking systems</strong>
              <p>Interactive, real-time visual tools that make complex data accessible and actionable.</p>
            </li>
            <li>
              <strong>Data governance, integration, and management systems</strong>
              <p>Frameworks ensuring data quality, security, privacy, and seamless integration across platforms.</p>
            </li>
            <li>
              <strong>Institutional data system audits and digital transformation roadmaps</strong>
              <p>Comprehensive assessments and phased plans to modernize data infrastructure sustainably.</p>
            </li>
            <li>
              <strong>Capacity building in R, STATA, SPSS, Power BI, and Python</strong>
              <p>Hands-on training and mentoring to build lasting in-house analytical capabilities.</p>
            </li>
          </ul>

          <div className="cta-section">
            <h3>Ready to Unlock Data-Driven Transformation?</h3>
            <div className="btn-group">
              <a href="/contact" className="btn btn-primary">
                Transform Your Data Systems <ArrowRight size={24} />
              </a>
              <a href="/services" className="btn btn-secondary">
                Explore All Services <ArrowRight size={24} />
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        {/* Paste the full footer here */}
      </footer>
    </>
  );
};

export default DataAnalytics;